var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.footer},[_c('div',{class:_vm.$style.footerInner},[_c('div',{staticClass:"ml-5 pl-5 d-flex justify-content-center align-items-center"},[_vm._v(" Copyright © "+_vm._s(_vm.$moment().format('Y'))+" PowerCommerce. All rights reserved. ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }